import Link from "next/link";

const chipClassName =
  "inline-flex max-w-full items-center rounded-full border border-blue-100 bg-white px-3 py-1 text-sm text-blue-900";

export function AuthorOrganizations({ organizations }) {
  if (!organizations || organizations.length === 0) return null;

  return (
    <div className="mx-auto my-2 flex w-full flex-wrap items-center justify-center gap-2 border-b border-gray-300 p-2 md:w-3/4">
      <span className="text-sm font-medium text-slate-600">
        Organizaciones
      </span>
      {organizations.map((organization) => {
        const key = organization.id || organization.label;
        if (organization.id) {
          return (
            <Link
              key={key}
              href={`/organization/${organization.id}`}
              className={`${chipClassName} transition-shadow hover:border-blue-300 hover:shadow-sm hover:underline`}
            >
              <span className="truncate">{organization.label}</span>
            </Link>
          );
        }
        return (
          <span key={key} className={chipClassName}>
            <span className="truncate">{organization.label}</span>
          </span>
        );
      })}
    </div>
  );
}
